import { render } from "./RestaurantConfigurations.vue?vue&type=template&id=f98788fa&ts=true"
import script from "./RestaurantConfigurations.vue?vue&type=script&lang=ts"
export * from "./RestaurantConfigurations.vue?vue&type=script&lang=ts"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__